import styled from 'styled-components';
import { LinearProgress } from '@material-ui/core';
import { Link } from 'react-router-dom';

export const Container = styled.div`
    margin-bottom: ${({ theme }) => theme.spacing * 15}px;
`;

export const FlexWrapper = styled.div`
    display: grid;
    justify-content: space-between;
    grid-template-columns: 1fr 80px;
    align-items: center;
    width: 100%;
    margin: ${({ theme }) => theme.spacing * 4}px 0;
`;
export const StyledLinearProgress = styled(LinearProgress)`
    && {
        border-radius: 4px;
        height: 8px;
        background-color: #062b541a;
        margin: ${({ theme }) => theme.spacing}px 0;

        .MuiLinearProgress-barColorPrimary {
            background-color: #00C853;
            border-radius: 4px;
        }
    }
`;

export const CampaignName = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 21px;
    color: ${({ theme }) => theme.colors.blue};
    opacity: .87;
`;

export const Percent = styled(CampaignName)`
    font-weight: bold;
    text-align: right;
`;

export const Numbers = styled.p`
    margin: 0;
    font-size: 12px;
    line-height: 21px;
    opacity: .87;
    color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
    font-weight: bold;
`;

export const ShowAll = styled(Link)`
    font-size: 12px;
    font-weight: bold;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.primary};
    margin: ${({ theme }) => theme.spacing * 4}px 
        0 ${({ theme }) => theme.spacing * 15}px;
    text-transform: uppercase;
    text-decoration: none;
`;

export const StyledLink = styled(Link)`
    text-decoration: none;
`;
